'use client';

import { useEffect } from 'react';
import { reportClientError } from '@/src/lib/errors/client-error-reporter';

export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
  useEffect(() => {
    reportClientError(error, {
      type: 'react',
      source: error.digest || undefined,
    });
  }, [error]);

  return (
    <html lang="fr">
      <body
        style={{
          margin: 0,
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '2rem',
          background: '#faf6f3',
          fontFamily: 'system-ui, -apple-system, sans-serif',
        }}
      >
        <div
          style={{
            maxWidth: '560px',
            width: '100%',
            background: '#fff',
            borderRadius: '16px',
            padding: '2rem',
            boxShadow: '0 10px 40px rgba(0,0,0,0.08)',
            textAlign: 'center',
          }}
        >
          <h1 style={{ color: '#6a5349', marginBottom: '1rem', fontSize: '1.5rem' }}>
            Oups, une erreur est survenue
          </h1>
          <p style={{ color: '#444', lineHeight: 1.5, marginBottom: '1.5rem' }}>
            L&apos;équipe technique a été alertée automatiquement. Vous pouvez rafraîchir la page
            ou revenir plus tard.
          </p>

          <div
            style={{
              background: '#f8f5f2',
              borderRadius: '12px',
              padding: '1rem',
              marginBottom: '1.5rem',
              textAlign: 'left',
            }}
          >
            <p
              style={{
                margin: 0,
                fontSize: '0.875rem',
                color: '#957365',
                fontWeight: 600,
                marginBottom: '0.5rem',
              }}
            >
              Détails de l&apos;erreur (à transmettre si besoin) :
            </p>
            <code
              style={{
                display: 'block',
                fontSize: '0.8rem',
                color: '#333',
                wordBreak: 'break-word',
                whiteSpace: 'pre-wrap',
              }}
            >
              {error?.message || 'Une erreur inattendue est survenue.'}
            </code>
          </div>

          <button
            type="button"
            onClick={() => window.location.reload()}
            style={{
              background: '#957365',
              color: '#fff',
              border: 'none',
              borderRadius: '8px',
              padding: '0.75rem 1.5rem',
              fontSize: '1rem',
              cursor: 'pointer',
            }}
          >
            Rafraîchir la page
          </button>
        </div>
      </body>
    </html>
  );
}
